module.exports = __webpack_public_path__ + "static/img/34.ca519bc0.jpeg";